__turbopack_context__.v({
  "sortMenuButton": "SortMenu-module-scss-module__baTsgG__sortMenuButton",
  "sortMenuButtonText": "SortMenu-module-scss-module__baTsgG__sortMenuButtonText",
});
